(() => {
  const STORAGE_KEY = "md_quote_v1";
  const API_BASE = "https://quote.medisa.au";

  const $ = (sel, root = document) => root.querySelector(sel);

  function loadQuote() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{"items":[]}');
    } catch {
      return { items: [] };
    }
  }

  function saveQuote(q) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(q));
  }

  function countItems(q) {
    return (q.items || []).reduce((s, i) => s + (i.qty || 0), 0);
  }

  function toNumericVariantId(id) {
    const s = String(id || "");
    if (s.includes("gid://shopify/ProductVariant/")) return s.split("/").pop();
    return s;
  }

  function autofillCustomerFields() {
    if (!window.MD_CUSTOMER) return;

    const c = window.MD_CUSTOMER;

    const setIfEmpty = (id, value) => {
      const el = document.querySelector(id);
      if (!el) return;
      if (!el.value) el.value = value || "";
    };

    setIfEmpty("#q_email", c.email);
    setIfEmpty("#q_first", c.firstName);
    setIfEmpty("#q_last", c.lastName);
    setIfEmpty("#q_phone", c.phone);
  }

  function syncBadge() {
    const q = loadQuote();
    const n = countItems(q);
    const iconWrap = $("#quote-icon-wrap");
    const badge = $("#quote-badge");
    if (!iconWrap || !badge) return;

    if (n > 0) {
      iconWrap.classList.remove("quote-hidden");
      badge.textContent = String(n);
      badge.classList.remove("quote-hidden");
    } else {
      iconWrap.classList.add("quote-hidden");
      badge.classList.add("quote-hidden");
    }
  }

  function openDrawer() {
    $("#quote-drawer-backdrop")?.classList.remove("quote-hidden");
    $("#quote-drawer")?.classList.add("open");
    autofillCustomerFields();
  }

  function closeDrawer() {
    $("#quote-drawer-backdrop")?.classList.add("quote-hidden");
    $("#quote-drawer")?.classList.remove("open");
  }

  function upsertItem(variantId, qty) {
    const q = loadQuote();
    const id = String(variantId);
    const n = Math.max(1, parseInt(qty, 10) || 1);
    const idx = (q.items || []).findIndex(x => String(x.variantId) === id);

    if (idx >= 0) q.items[idx].qty += n;
    else q.items.push({ variantId: id, qty: n });

    saveQuote(q);
    syncBadge();
    openDrawer();
    renderDrawer();
  }

  function setQty(variantId, qty) {
    const q = loadQuote();
    const id = String(variantId);
    const n = Math.max(1, parseInt(qty, 10) || 1);
    const it = (q.items || []).find(x => String(x.variantId) === id);

    if (it) it.qty = n;

    saveQuote(q);
    syncBadge();
    renderDrawer();
  }

  function removeItem(variantId) {
    const q = loadQuote();
    const id = String(variantId);

    q.items = (q.items || []).filter(x => String(x.variantId) !== id);

    saveQuote(q);
    syncBadge();
    renderDrawer();
  }

  function clearQuote() {
    saveQuote({ items: [] });
    syncBadge();
    renderDrawer();
  }

  async function priceQuote(items) {
    const resp = await fetch(`${API_BASE}/quote/price`, {
      method: "POST",
      headers: { "content-type": "text/plain;charset=UTF-8" },
      body: JSON.stringify({ items })
    });

    const json = await resp.json();
    if (!json.ok) throw new Error(json.message || "Pricing failed");

    return json;
  }

  function getFormData() {
    return {
      customer: {
        firstName: $("#q_first")?.value || "",
        lastName: $("#q_last")?.value || "",
        company: $("#q_company")?.value || "",
        email: $("#q_email")?.value || "",
        phone: $("#q_phone")?.value || "",
      },
      address: {
        address1: $("#q_addr1")?.value || "",
        address2: $("#q_addr2")?.value || "",
        city: $("#q_city")?.value || "",
        province: $("#q_state")?.value || "",
        zip: $("#q_zip")?.value || "",
        country: $("#q_country")?.value || "",
      }
    };
  }

  async function submitQuote() {
    const q = loadQuote();
    if (!q.items?.length) return;

    const btn = $("#q_submit");
    const err = $("#q_error");
    const ok = $("#q_ok");

    if (err) err.textContent = "";
    if (ok) ok.textContent = "";

    try {
      if (btn) {
        btn.disabled = true;
        btn.textContent = "Submitting...";
      }

      const payload = { ...getFormData(), items: q.items };

      const resp = await fetch(`${API_BASE}/quote/submit`, {
        method: "POST",
        headers: { "content-type": "text/plain;charset=UTF-8" },
        body: JSON.stringify(payload)
      });

      const json = await resp.json();
      if (!json.ok) throw new Error(json.message || "Submit failed");

      if (ok) ok.textContent = `Quote submitted successfully (${json.quoteNo}). Check your email.`;
      clearQuote();
    } catch (e) {
      if (err) err.textContent = String(e.message || e);
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = "Submit Quote";
      }
    }
  }

  async function renderDrawer() {
    const q = loadQuote();
    const list = $("#q_items");
    const subtotalEl = $("#q_subtotal");
    const totalEl = $("#q_total");

    if (!list || !subtotalEl || !totalEl) return;

    if (!q.items?.length) {
      list.innerHTML = `<div class="quote-small">No items added yet.</div>`;
      subtotalEl.textContent = "AUD 0.00";
      totalEl.textContent = "AUD 0.00";
      return;
    }

    list.innerHTML = `<div class="quote-small">Loading items...</div>`;

    try {
      const priced = await priceQuote(q.items);

      list.innerHTML = priced.lines.map(l => {
        const vid = toNumericVariantId(l.variantId);

        return `
          <div class="quote-row">
            <div class="meta">
              <div class="title">${escapeHtml(l.productTitle)}</div>
              <div class="sub">${escapeHtml(l.variantTitle)}${l.sku ? ` • ${escapeHtml(l.sku)}` : ""}</div>
              <div class="sub">
                <a href="/products/${escapeHtml(l.productHandle)}" target="_blank" rel="noopener">View product</a>
              </div>
            </div>

            <div class="quote-actions">
              <div class="qty">
                <button type="button" class="qbtn" data-qminus="${vid}" aria-label="Decrease">−</button>
                <input class="qty-input" value="${l.qty}" data-qtyinp="${vid}" inputmode="numeric">
                <button type="button" class="qbtn" data-qplus="${vid}" aria-label="Increase">+</button>
              </div>

              <div class="sub right">AUD ${Number(l.lineTotal).toFixed(2)}</div>
              <button type="button" class="qremove" data-qremove="${vid}">Remove</button>
            </div>
          </div>
        `;
      }).join("");

      subtotalEl.textContent = `AUD ${Number(priced.subtotal).toFixed(2)}`;
      totalEl.textContent = `AUD ${Number(priced.total).toFixed(2)}`;
    } catch (e) {
      list.innerHTML = `<div class="quote-small">Error loading prices: ${escapeHtml(String(e.message || e))}</div>`;
      subtotalEl.textContent = "AUD 0.00";
      totalEl.textContent = "AUD 0.00";
    }

    list.querySelectorAll("[data-qminus]").forEach(btn => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-qminus");
        const q2 = loadQuote();
        const it = q2.items.find(x => String(x.variantId) === String(id));
        if (!it) return;

        const next = Math.max(1, (it.qty || 1) - 1);
        setQty(id, next);
      });
    });

    list.querySelectorAll("[data-qplus]").forEach(btn => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-qplus");
        const q2 = loadQuote();
        const it = q2.items.find(x => String(x.variantId) === String(id));
        if (!it) return;

        setQty(id, (it.qty || 1) + 1);
      });
    });

    list.querySelectorAll("[data-qremove]").forEach(btn => {
      btn.addEventListener("click", () => removeItem(btn.getAttribute("data-qremove")));
    });

    list.querySelectorAll("[data-qtyinp]").forEach(inp => {
      inp.addEventListener("change", () => setQty(inp.getAttribute("data-qtyinp"), inp.value));
    });
  }

  function escapeHtml(s) {
    return String(s ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;");
  }
function getCurrentVariantId() {
  const urlVariant = new URLSearchParams(window.location.search).get("variant");
  if (urlVariant) return urlVariant;

  const variantInput =
    document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
    document.querySelector('input[name="id"]') ||
    document.querySelector('select[name="id"]');

  if (variantInput && variantInput.value) return variantInput.value;

  const btn = document.querySelector("#md-add-to-quote");
  return btn?.getAttribute("data-variant-id") || "";
}

function syncAddToQuoteVariantId() {
  const btn = document.querySelector("#md-add-to-quote");
  if (!btn) return;

  const variantId = getCurrentVariantId();
  if (!variantId) return;

  btn.setAttribute("data-variant-id", variantId);
}
  function initProductButtons() {
  syncAddToQuoteVariantId();

  document.addEventListener("change", (e) => {
    if (
      e.target.matches('input[name="id"]') ||
      e.target.matches('select[name="id"]') ||
      e.target.matches('input[type="radio"]') ||
      e.target.matches('select')
    ) {
      setTimeout(syncAddToQuoteVariantId, 80);
      setTimeout(syncAddToQuoteVariantId, 250);
    }
  });

  document.addEventListener("click", (e) => {
    setTimeout(syncAddToQuoteVariantId, 80);
    setTimeout(syncAddToQuoteVariantId, 250);

    const btn = e.target.closest("[data-add-to-quote]");
    if (!btn) return;

    syncAddToQuoteVariantId();

    const variantId = btn.getAttribute("data-variant-id");
    const qtySel = document.querySelector('input[name="quantity"]');
    const qty = qtySel ? qtySel.value : 1;

    if (!variantId) {
      alert("Variant not selected.");
      return;
    }

    upsertItem(variantId, qty);
  });

  window.addEventListener("popstate", syncAddToQuoteVariantId);
}

  function repositionAddToQuoteButton() {
  const btn = document.querySelector("#md-add-to-quote");
  if (!btn) return;

  const atcBtn =
    document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
    document.querySelector('button[name="add"]') ||
    document.querySelector('button[type="submit"]');

  if (!atcBtn || !atcBtn.parentElement) return;

  function findSampleBtn() {
    return [...document.querySelectorAll("button")]
      .find(b => b.textContent.trim().toLowerCase() === "request sample");
  }

  function styleLikeSample(sampleBtn) {
    const refStyles = window.getComputedStyle(sampleBtn);

    btn.style.cssText = [
      `width:${sampleBtn.offsetWidth}px`,
      `height:${sampleBtn.offsetHeight}px`,
      `border-radius:${refStyles.borderRadius}`,
      "border:2px solid rgba(0,0,0,.25)",
      "background:transparent",
      "color:#111",
      "font-weight:700",
      "font-size:15px",
      "cursor:pointer",
      "box-sizing:border-box",
    ].join(";");
  }

  function placeButtonsTogether() {
  const sampleBtn = findSampleBtn();

  if (!sampleBtn || !sampleBtn.parentElement) return false;

  let row = document.querySelector(".md-extra-buttons-row");

  if (!row) {
    row = document.createElement("div");
    row.className = "md-extra-buttons-row";
    sampleBtn.parentElement.insertAdjacentElement("beforebegin", row);
  }

  row.appendChild(btn);
  row.appendChild(sampleBtn);

  const realAtcBtn = [...document.querySelectorAll("button")]
    .find(b => b.textContent.trim().toLowerCase() === "add to cart");

  const buyNowBtn = [...document.querySelectorAll("button")]
    .find(b => {
      const txt = b.textContent.trim().toLowerCase();
      return txt.includes("buy") || txt.includes("shop");
    });

  const refAtc = realAtcBtn || atcBtn;

  const atcRect = refAtc.getBoundingClientRect();
  const atcW = Math.round(atcRect.width);
  const atcH = Math.round(atcRect.height);

  let gap = 12;

  if (buyNowBtn) {
    const buyRect = buyNowBtn.getBoundingClientRect();
    const calculatedGap = Math.round(buyRect.left - atcRect.right);
    if (calculatedGap > 0) gap = calculatedGap;
  }

  row.style.setProperty("display", "grid", "important");
  row.style.setProperty("grid-template-columns", `${atcW}px ${atcW}px`, "important");
  row.style.setProperty("column-gap", `${gap}px`, "important");
  row.style.setProperty("margin-top", "12px", "important");
  row.style.setProperty("width", "fit-content", "important");
  row.style.setProperty("align-items", "center", "important");

  [btn, sampleBtn].forEach((b) => {
    b.removeAttribute("class");

    b.style.setProperty("width", `${atcW}px`, "important");
    b.style.setProperty("height", `${atcH}px`, "important");
    b.style.setProperty("min-width", `${atcW}px`, "important");
    b.style.setProperty("max-width", `${atcW}px`, "important");
    b.style.setProperty("min-height", `${atcH}px`, "important");
    b.style.setProperty("max-height", `${atcH}px`, "important");
    b.style.setProperty("margin", "0", "important");
    b.style.setProperty("padding", "0 18px", "important");
    b.style.setProperty("display", "flex", "important");
    b.style.setProperty("align-items", "center", "important");
    b.style.setProperty("justify-content", "center", "important");
    b.style.setProperty("box-sizing", "border-box", "important");
    b.style.setProperty("border-radius", "24px", "important");
    b.style.setProperty("border", "2px solid rgba(0,0,0,.25)", "important");
    b.style.setProperty("background", "transparent", "important");
    b.style.setProperty("color", "#111", "important");
    b.style.setProperty("font-weight", "700", "important");
    b.style.setProperty("font-size", "15px", "important");
    b.style.setProperty("line-height", "1", "important");
    b.style.setProperty("cursor", "pointer", "important");
  });

  return true;
}

  // Try immediately
  if (placeButtonsTogether()) return;

  // Fallback while waiting for Sample Request button to be created
  const tempWrap = document.createElement("div");
  tempWrap.className = "md-gq-button-wrap";
  tempWrap.style.marginTop = "10px";
  tempWrap.appendChild(btn);
  atcBtn.parentElement.insertAdjacentElement("afterend", tempWrap);

  // Try again after Sample Request JS renders
  let attempts = 0;
  const timer = setInterval(() => {
    attempts++;

    if (placeButtonsTogether() || attempts > 20) {
      clearInterval(timer);
    }
  }, 250);
}

  function initDrawerChrome() {
    $("#quote-open")?.addEventListener("click", (e) => {
      e.preventDefault();
      openDrawer();
      renderDrawer();
    });

    $("#quote-close")?.addEventListener("click", (e) => {
      e.preventDefault();
      closeDrawer();
    });

    $("#quote-drawer-backdrop")?.addEventListener("click", closeDrawer);

    $("#q_submit")?.addEventListener("click", (e) => {
      e.preventDefault();
      submitQuote();
    });
  }

  window.MD_QUOTE = {
    upsertItem,
    openDrawer,
    closeDrawer,
    renderDrawer
  };

  document.addEventListener("DOMContentLoaded", () => {
  // repositionAddToQuoteButton(); // disabled: button layout is now controlled by Liquid/CSS
  syncAddToQuoteVariantId();
  syncBadge();
  initProductButtons();
  initDrawerChrome();
  // renderDrawer();
});
})();